import { AppConfig } from "../config";

export const mainColor = AppConfig.mainColor